import { convertHedStringToLong, convertHedStringToShort } from './converter'

export { convertHedStringToLong, convertHedStringToShort }

export default {
  convertHedStringToLong,
  convertHedStringToShort,
}
